import script from "./ResultadosView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultadosView.vue?vue&type=script&setup=true&lang=js"

import "./ResultadosView.vue?vue&type=style&index=0&id=59f36bd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f36bd3"]])

export default __exports__